/* ASSET: assets/villa318-pack-selector.js
   Villa 318 Multipack Selector — FULL REPLACEMENT (per latest UI decisions)

   Changes included:
   ✅ Remove "Each pack includes X mugs" helper line entirely (Add to cart sits directly under Quantity)
   ✅ Discount label becomes "(SAVE 16%)" (not "(16% off)")
   ✅ Main PDP price (below title) appends "(SAVE 16%)" to the right of the selected pack price
      - Only shown when computed discount >= 5%
      - Hidden for Single
   ✅ Keeps:
      - Inline discount on selector row
      - Inline Best Value pill
      - Strikethrough full-value pricing (single * qty) when discount >= 5% and truly cheaper
      - Main PDP price updates on pack selection and restores on Single
*/
(() => {
  const PACK_QTY = { single: 1, "2": 2, "4": 4 };
  const MIN_DISCOUNT_PCT_TO_SHOW = 5;

  function centsToMoney(cents) {
    try {
      if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
        return window.Shopify.formatMoney(cents);
      }
    } catch (_) {}
    return new Intl.NumberFormat(undefined, { style: "currency", currency: "USD" }).format((cents || 0) / 100);
  }

  function computePctOff(singlePriceCents, packPriceCents, packQty) {
    if (!singlePriceCents || !packPriceCents || !packQty) return null;
    const singleUnit = singlePriceCents;
    const packUnit = packPriceCents / packQty;
    const raw = (1 - packUnit / singleUnit) * 100;
    const pct = Math.round(raw);
    if (!Number.isFinite(pct) || pct < MIN_DISCOUNT_PCT_TO_SHOW) return null;
    return pct;
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, (c) => ({
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
    }[c]));
  }

  function escapeAttr(s) {
    return escapeHtml(s).replace(/`/g, "&#96;");
  }

  function findNearestVariantIdInput(mountEl) {
    const root = mountEl.closest("section") || document;
    const candidates = [
      mountEl.closest("product-form"),
      mountEl.closest("form"),
      root.querySelector("product-form"),
      root.querySelector('form[action^="/cart/add"]'),
      document.querySelector('form[action^="/cart/add"]'),
    ].filter(Boolean);

    for (const el of candidates) {
      const form =
        el.tagName === "FORM"
          ? el
          : el.querySelector?.('form[action^="/cart/add"]') ||
            el.querySelector?.("form") ||
            null;
      const scope = form || el;
      const input = scope.querySelector?.('input[name="id"]');
      if (input) return input;
    }
    return null;
  }

  function findNearestPriceContainer(mountEl) {
    const scope = mountEl.closest("section") || document;
    const nearInfo =
      mountEl.closest(".product__info-container") ||
      mountEl.closest(".product__info-wrapper") ||
      mountEl.parentElement;

    const selectors = [
      ".price",
      "[data-price]",
      "[data-product-price]",
      ".product__info-container .price",
      ".product__info-wrapper .price",
    ];

    for (const sel of selectors) {
      const el = (nearInfo && nearInfo.querySelector?.(sel)) || scope.querySelector(sel);
      if (el) return el;
    }
    return null;
  }
function setPriceCentsDataset(priceContainer, priceCents) {
  if (!priceContainer) return;
  if (typeof priceCents !== "number" || !Number.isFinite(priceCents)) return;

  const centsStr = String(Math.round(priceCents));

  // Set on the element we update
  priceContainer.dataset.v318SelectedPriceCents = centsStr;

  // ALSO set on the wrapper <div id="price-{{ section.id }}"> if present
  const wrap =
    priceContainer.closest('[id^="price-"]') ||
    priceContainer.parentElement?.closest?.('[id^="price-"]') ||
    null;

  if (wrap) wrap.dataset.v318SelectedPriceCents = centsStr;
}

function renderMainPriceHTML({ priceCents, compareCents, savePct }) {
  const price = `<span class="price-item v318-main-price">${escapeHtml(centsToMoney(priceCents))}</span>`;

  const compare =
    compareCents && compareCents > priceCents
      ? `<span class="price-item v318-main-compare"><s>${escapeHtml(centsToMoney(compareCents))}</s></span>`
      : "";

  const save =
    typeof savePct === "number"
      ? `<span class="price-item v318-main-save">SAVE ${savePct}%</span>`
      : "";

  return `<span class="v318-main-price-row">${price}${compare}${save}</span>`;
}


  function normalizeOrder(order, packs) {
    const seen = new Set();
    const out = [];
    for (const t of Array.isArray(order) ? order : []) {
      const token = String(t).trim();
      if (!token || seen.has(token)) continue;
      if (!packs[token] || !packs[token].variant_id) continue;
      out.push(token);
      seen.add(token);
    }
    if (!seen.has("single") && packs.single?.variant_id) out.unshift("single");
    return out;
  }

  function buildOptionHTML({ token, label, totalCents, pctOff, badge, compareCents }) {
    // Discount format: "(SAVE 16%)"
    const offInline =
      pctOff !== null ? `<span class="v318-pack-off-inline">(SAVE ${pctOff}%)</span>` : "";

    const badgeInline = badge ? `<span class="v318-pack-badge-pill">${escapeHtml(badge)}</span>` : "";

    const rightPrice =
      compareCents && compareCents > totalCents
        ? `<span class="v318-pack-compare"><s>${escapeHtml(centsToMoney(compareCents))}</s></span>
           <span class="v318-pack-price">${escapeHtml(centsToMoney(totalCents))}</span>`
        : `<span class="v318-pack-price">${escapeHtml(centsToMoney(totalCents))}</span>`;

    return `
      <button type="button" class="v318-pack-btn" data-pack-token="${escapeAttr(token)}" aria-pressed="false">
        <div class="v318-pack-top">
          <div class="v318-pack-left">
            <span class="v318-pack-label">${escapeHtml(label)}</span>
            ${offInline}
            ${badgeInline}
          </div>
          <div class="v318-pack-right">
            ${rightPrice}
          </div>
        </div>
      </button>
    `;
  }

  function injectStylesOnce() {
    if (document.getElementById("villa318-pack-selector-styles")) return;

    const style = document.createElement("style");
    style.id = "villa318-pack-selector-styles";
    style.textContent = `
      .villa318-pack-selector { margin: 12px 0 12px; }
      .v318-pack-wrap { display: grid; gap: 8px; }

      .v318-pack-btn {
        width: 100%;
        text-align: left;
        border: 1px solid rgba(0,0,0,.12);
        border-radius: 10px;
        padding: 10px 12px;
        background: #fff;
        cursor: pointer;
      }
     .v318-pack-btn[aria-pressed="true"] {
  border-color: #000;
  border-width: 2px;
  box-shadow: none;
    background: rgba(0,0,0,.02);
}


      .v318-pack-top { display:flex; align-items:flex-start; justify-content:space-between; gap: 12px; }

      .v318-pack-left {
        display:flex;
        flex-wrap: wrap;
        align-items:baseline;
        gap: 8px;
        min-width: 0;
      }
      .v318-pack-label { font-weight: 650; }

      .v318-pack-off-inline {
        font-weight: 650;
        color: rgba(25, 140, 60, 1);
        white-space: nowrap;
      }

      .v318-pack-right { display:flex; align-items:baseline; gap: 8px; white-space: nowrap; }
      .v318-pack-compare { opacity: .65; }
      .v318-pack-price { white-space: nowrap; font-weight: 650; }

      .v318-pack-badge-pill {
        display: inline-block;
        font-size: 12px;
        font-weight: 700;
        padding: 2px 8px;
        border-radius: 999px;
        border: 1px solid rgba(0,0,0,.12);
        opacity: .95;
        white-space: nowrap;
      }

      .v318-pack-help { font-size: 12px; opacity: .75; margin-bottom: 6px; }

      /* Main price "SAVE" badge next to price (below title) */
      .v318-main-price-row {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.v318-main-price,
.v318-main-compare,
.v318-main-save {
  font-size: inherit;
  line-height: inherit;
}

.v318-main-compare {
  opacity: .65;
}

.v318-main-save {
  font-weight: 650;
  color: rgba(25, 140, 60, 1);
  white-space: nowrap;
}
    `;
    document.head.appendChild(style);
  }

  function initOne(productId) {
    const dataEl = document.getElementById(`Villa318PackSelectorData-${productId}`);
    const mountEl = document.getElementById(`Villa318PackSelector-${productId}`);
    if (!dataEl || !mountEl) return;

    let data;
    try {
      data = JSON.parse(dataEl.textContent || "{}");
    } catch {
      return;
    }
    if (!data.enabled || !data.packs || !data.packs.single?.variant_id) return;

    const packs = data.packs;
    const order = normalizeOrder(data.order, packs);

    let active = String(data.default || "single").trim();
    if (!packs[active]?.variant_id) active = order[0] || "single";
    if (!packs[active]?.variant_id) return;

    injectStylesOnce();

    const singlePrice = packs.single.price_cents;

    const optionsHtml = order
      .map((token) => {
        const p = packs[token];
        const qty = PACK_QTY[token] || 1;

        const pctOff = token === "single" ? null : computePctOff(singlePrice, p.price_cents, qty);

        let compareCents = null;
        if (token !== "single" && pctOff !== null) {
          const fullValue = singlePrice * qty;
          if (p.price_cents < fullValue) compareCents = fullValue;
        }

        return buildOptionHTML({
          token,
          label: p.label || token,
          totalCents: p.price_cents,
          pctOff,
          badge: p.badge,
          compareCents,
        });
      })
      .join("");

    mountEl.innerHTML = `
      <div class="v318-pack-help">Buy more and save.</div>
      <div class="v318-pack-wrap">${optionsHtml}</div>
    `;

    const variantInput = findNearestVariantIdInput(mountEl);
    if (!variantInput) return;

    const priceContainer = findNearestPriceContainer(mountEl);
    const originalPriceHTML = priceContainer ? priceContainer.innerHTML : null;

    // Save badge element (in main price) so we can update/remove it cleanly
    const saveBadgeId = `V318MainSave-${productId}`;

    

    function updateMainPrice(token) {
      if (!priceContainer) return;

      if (token === "single") {
        if (originalPriceHTML !== null) priceContainer.innerHTML = originalPriceHTML;
        setPriceCentsDataset(priceContainer, packs.single.price_cents);
        // Ensure no leftover badge
        return;
      }

      const qty = PACK_QTY[token] || 1;
      const packPrice = packs[token].price_cents;

      const pctOff = computePctOff(packs.single.price_cents, packPrice, qty);

      let compareCents = null;
      if (pctOff !== null) {
        const fullValue = packs.single.price_cents * qty;
        if (packPrice < fullValue) compareCents = fullValue;
      }

priceContainer.innerHTML = renderMainPriceHTML({ priceCents: packPrice, compareCents, savePct: pctOff });
setPriceCentsDataset(priceContainer, packPrice);

    }

    function setActive(token) {
      active = token;

      // Update variant id in add-to-cart form
variantInput.value = String(packs[token].variant_id);
document.dispatchEvent(
  new CustomEvent("villa318:pack-change", {
    bubbles: true,
    detail: {
      token: token,
      variantId: Number(packs[token].variant_id),
      priceCents: Number(packs[token].price_cents)
    }
  })
);


// Notify theme + any other scripts (like Dynamic USP bar)
variantInput.dispatchEvent(new Event("change", { bubbles: true }));

// Some themes listen for variant:change on document
document.dispatchEvent(new CustomEvent("variant:change", { bubbles: true }));

      // Update pressed state
      mountEl.querySelectorAll(".v318-pack-btn").forEach((btn) => {
        const t = btn.getAttribute("data-pack-token");
        btn.setAttribute("aria-pressed", t === active ? "true" : "false");
      });

      updateMainPrice(token);
    }

    mountEl.addEventListener("click", (e) => {
      const btn = e.target.closest?.(".v318-pack-btn");
      if (!btn) return;
      const token = btn.getAttribute("data-pack-token");
      if (!token || !packs[token]?.variant_id) return;
      setActive(token);
    });

    setActive(active);
  }

  function initAll() {
    document.querySelectorAll('[id^="Villa318PackSelector-"][data-product-id]').forEach((el) => {
      const pid = el.getAttribute("data-product-id");
      if (pid) initOne(pid);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
})();
